module.exports = __webpack_public_path__ + "img/coffin-cross.9db35fa2.svg";